/**
 * Do not edit directly
 * Generated on Mon, 03 Jan 2022 21:08:12 GMT
 */
export const StrokeS = "1px";
export const StrokeM = "2px";
export const StrokeL = "3px";
export const StrokeXl = "4px";
